import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TransformChainTestDialog} from '../common/transformChainTestDialog.js';

export var IntegrationGuideDialog = {

	show(options) {
		var transmissionType = options.transmissionType;
		var transmissionTypes = options.transmissionTypes || [];
		var onTransmissionChange = options.onTransmissionChange;

		var guideWin = ElementUtil.create({
			tag: 'dl-dialog',
			title: 'Integration Configuration Guide',
			icon: 'vaadin:book',
			width: 0.85,
			height: 0.85,
			listeners: {
				ready: function () {
					guideWin.show();
					var contentRoot = ElementUtil.create({
						tag: 'div',
						itemid: 'guide-content',
						style: 'padding: 12px;'
					});
					guideWin.addToContentElement(contentRoot);

					contentRoot.addEventListener('click', function (event) {
						var link = event.target.closest('[data-action="transform-chain-tester"]');
						if (link) {
							event.preventDefault();
							TransformChainTestDialog.show({});
						}
					});

					var toolbarChildren = [
						{
							tag: 'vaadin-button',
							theme: 'tertiary',
							children: [
								ElementUtil.makeIcon('vaadin:tools', ' Transform chain tester')
							],
							listeners: {
								click: function () {
									TransformChainTestDialog.show({});
								}
							}
						}
					];
					if (transmissionTypes.length > 0) {
						toolbarChildren.push({
							tag: 'vaadin-combo-box',
							itemId: 'guide-trans-type',
							label: 'Transmission Type',
							style: 'min-width: 280px;',
							'item-value-path': 'transmissionType',
							'item-label-path': 'transmissionDescription',
							value: transmissionType,
							postinit: function (combo) {
								combo.items = transmissionTypes.slice(0);
							},
							listeners: {
								change: function () {
									var selected = ElementUtil.query(guideWin, 'guide-trans-type').value;
									if (selected) {
										loadGuide(selected);
										if (onTransmissionChange) {
											onTransmissionChange(selected);
										}
									}
								}
							}
						});
					}
					if (toolbarChildren.length > 0) {
						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: toolbarChildren
						});
						guideWin.appendChild(toolbar);
					}

					function renderGuide(guide) {
						contentRoot.innerHTML = '';
						if (!guide) {
							contentRoot.innerHTML = '<p>No guide available for this transmission type.</p>';
							return;
						}

						var html = '';
						html += '<h2>' + escapeHtml(guide.transmissionDescription || guide.transmissionType) + '</h2>';
						if (guide.overview) {
							html += '<p><strong>Overview</strong></p><p>' + escapeHtml(guide.overview) + '</p>';
						}
						if (guide.frameworkAppendix) {
							html += '<div class="integration-guide-framework">' + guide.frameworkAppendix + '</div>';
						}
						if (guide.scenarios && guide.scenarios.length > 0) {
							html += '<h3>Scenarios</h3><ul>';
							guide.scenarios.forEach(function (scenario) {
								html += '<li><strong>' + escapeHtml(scenario.title) + '</strong>: '
										+ escapeHtml(scenario.description) + '</li>';
							});
							html += '</ul>';
						}
						html += renderPropertiesSection('Integration options', guide.configProperties);
						if (guide.filePropertiesByDataType) {
							guide.filePropertiesByDataType.forEach(function (fileSection) {
								var title = 'File options — ' + (fileSection.dataType || 'Data type');
								if (fileSection.fileGuideNote) {
									html += '<p><em>' + escapeHtml(fileSection.fileGuideNote) + '</em></p>';
								}
								html += renderPropertiesSection(title, fileSection.properties);
							});
						}
						if (guide.resourceSections && guide.resourceSections.length > 0) {
							guide.resourceSections.forEach(function (section) {
								html += '<h3>' + escapeHtml(section.title || 'Details') + '</h3>';
								html += '<div class="integration-guide-resource">' + (section.html || '') + '</div>';
							});
						}
						if (guide.adminNotesHtml) {
							html += '<h3>Operational notes (admin)</h3>';
							html += '<div class="integration-guide-admin-notes">' + guide.adminNotesHtml + '</div>';
							html += '<p><small>Page key: <code>integration-guide:'
									+ escapeHtml(guide.transmissionType) + '</code> — edit via Help Management.</small></p>';
						}
						contentRoot.innerHTML = html;
					}

					function renderPropertiesSection(title, properties) {
						if (!properties || properties.length === 0) {
							return '';
						}
						var sectionHtml = '<h3>' + escapeHtml(title) + '</h3>'
								+ '<table class="detail-table" style="margin-bottom: 16px;">';
						sectionHtml += '<thead><tr>'
								+ '<th>Option</th><th>Scope</th><th>Description</th>'
								+ '</tr></thead><tbody>';
						properties.forEach(function (prop) {
							sectionHtml += '<tr>';
							sectionHtml += '<td style="vertical-align:top;">'									
									+ escapeHtml(prop.label || '') + '<br><code style="font-size:10px">('
									+ escapeHtml(prop.optionName) + ')</code>'
									+ '</td>';
							sectionHtml += '<td style="vertical-align:top;">'
									+ escapeHtml(prop.propertyScope || '') + '</td>';
							sectionHtml += '<td style="vertical-align:top;">';
							if (prop.helpText) {
								sectionHtml += escapeHtml(prop.helpText);
							}
							if (prop.overrideNote) {
								sectionHtml += '<br><em>' + escapeHtml(prop.overrideNote) + '</em>';
							}
							if (prop.defaultValue) {
								sectionHtml += '<br>Default: ' + escapeHtml(prop.defaultValue);
							}
							sectionHtml += '</td></tr>';
						});
						sectionHtml += '</tbody></table>';
						return sectionHtml;
					}

					function escapeHtml(text) {
						if (text == null) {
							return '';
						}
						return String(text)
								.replace(/&/g, '&amp;')
								.replace(/</g, '&lt;')
								.replace(/>/g, '&gt;')
								.replace(/"/g, '&quot;');
					}

					function loadGuide(type) {
						contentRoot.innerHTML = '<p>Loading guide...</p>';
						DataManagementService.getIntegrationService().getIntegrationGuide(type).then(function (guide) {
							renderGuide(guide);
						}).catch(function () {
							contentRoot.innerHTML = '<p>Failed to load integration guide.</p>';
						});
					}

					if (transmissionType) {
						loadGuide(transmissionType);
					} else {
						contentRoot.innerHTML = '<p>Select a transmission type to view the guide.</p>';
					}
				}
			}
		});
	}
};
